import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { IntegrationSyncRun, IntegrationSyncRunCreate, IntegrationSyncRunFilter } from '../data/integrationSyncRun';

export function createIntegrationSyncRunService(client: AxiosInstance) {
  return createCrudService<IntegrationSyncRun, IntegrationSyncRunCreate, IntegrationSyncRunFilter>(
    client,
    '/integration/IntegrationSyncRun',
    'id',
  );
}

export type IntegrationSyncRunService = CrudService<IntegrationSyncRun, IntegrationSyncRunCreate, IntegrationSyncRunFilter>;
